import { Inject, Injectable, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppConfigService } from '../../shared/appconfig/appconfig.service'

import { Lookup } from '../../shared/models/core.model';

@Injectable({
  providedIn: 'root'
})
export class LookupService {

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
  }

  getGroup(group) {

    return this.http.get<Lookup[]>(AppConfigService.settings.get('chatstyleapiServer') + 'lookups/' + group);

  }



}


